<div class="container-fluid forDashboard">
    <div class="row">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <mat-card>
              <mat-card-title>
                <h2>Employee Details</h2>
              </mat-card-title>
              <mat-card-content style="display: flex; align-items: center; justify-content: space-between; min-height: 50px !important;">
                <!-- Employee Details Section -->
                <div>
                  <div class="row">
                    <div
                      class="col-12"
                      *ngIf="user_details?.user_id"
                      style="display: flex; align-items: center; margin-bottom: 10px;"
                    >
                      <h3 style="margin: 0; text-align: left; padding-right: 10px;">Employee Name:</h3>
                      <b style="text-align: left;">{{ user_details?.username }}</b>
                    </div>
                    <div
                      class="col-12"
                      *ngIf="user_details?.user_id"
                      style="display: flex; align-items: center;"
                    >
                      <h3 style="margin: 0; text-align: left; padding-right: 10px;">Employee ID:</h3>
                      <b style="text-align: left;">INT{{ formatUserId(user_details?.user_id) }}</b>
                    </div>
                  </div>
                </div>
                <!-- Image Section -->
                <!-- <div>
                    <a
                      [href]="environment.REST_API_URL + '/api/web/uploads/' + user_details?.profile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img
                        [src]="environment.REST_API_URL + '/api/web/uploads/' + user_details?.profile"
                        alt="Uploaded Image"
                        style="width: 150px; height: 150px; object-fit: cover; border: 1px solid #ccc; border-radius: 8px;"
                      />
                    </a>
                  </div> -->
              </mat-card-content>
            </mat-card>
          </div>          
        <div class="cal-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <mat-card>
                <mat-card-title>
                    <h2> Shifts Details</h2>
                </mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <div class="col-12" *ngIf="(shiftStartAt != '') && (shiftEndAt != '');">
                            <h3>{{shiftStartAt}} to {{shiftEndAt}} </h3>
                        </div>

                    </div>
                    <form>
                        <agm-map style="height: 300px;" [latitude]="currentLat" [longitude]="currentLong" [zoom]="zoom" style="display: none;">
                            <agm-marker [latitude]="currentLat" [longitude]="currentLong"></agm-marker>
                        </agm-map>
                    </form>
                    <div class="row">
                        <div class="col-12">
                            <h3>{{date | date:'EEEE, MMMM d, y'}}</h3>
                        </div>
                    </div>
                    <app-clock></app-clock>

                    <div class="row" style="display: none;">
                        <div class="col-12" *ngIf="working_on !=''">
                            <p>{{working_on}}</p>
                        </div>
                    </div>

                    <mat-card-actions>
                        <form>
                            <div *ngIf="isNewTaskShow">

                                <button type="button" mat-raised-button class="btn-int-blue forActionButton" (click)="createAttendance()" [disabled]="isDisabled" [innerHtml]="eventTypeTxt">c </button>
                            </div>
                            <div *ngIf="!isNewTaskShow">
                                <button type="button" mat-raised-button class="btn-int-blue forActionButton" (click)="workingOn();" [disabled]="isDisabled" [innerHtml]="eventTypeTxt"> c</button>
                            </div>
                        </form>
                    </mat-card-actions>

                </mat-card-content>

            </mat-card>
        </div>

        <div class="cal-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <mat-card>
                <mat-card-title>
                    <h2>Leaves</h2>
                </mat-card-title>
                <mat-card-content>

                    <div class="mat-table-responsive forFixedHeight">
                        <table mat-table [dataSource]="leavesDataSource">

                            <ng-container matColumnDef="org_name" [sticky]="1 == 1">
                                <th mat-header-cell *matHeaderCellDef>Organization </th>
                                <td mat-cell *matCellDef="let element"> {{element.org_name}} </td>
                            </ng-container>

                            <ng-container matColumnDef="applied_user" [sticky]="1 == 1">
                                <th mat-header-cell *matHeaderCellDef> Name </th>
                                <td mat-cell *matCellDef="let element"> {{element.applied_user}} </td>
                            </ng-container>

                            <ng-container matColumnDef="leave_from">
                                <th mat-header-cell *matHeaderCellDef> Leave From </th>
                                <td mat-cell *matCellDef="let element"> {{element.leave_from}} </td>
                            </ng-container>

                            <ng-container matColumnDef="leave_to">
                                <th mat-header-cell *matHeaderCellDef>Leave To </th>
                                <td mat-cell *matCellDef="let element"> {{element.leave_to}} </td>
                            </ng-container>

                            <ng-container matColumnDef="leave_days">
                                <th mat-header-cell *matHeaderCellDef> Leave Days </th>
                                <td mat-cell *matCellDef="let element"> {{element.leave_days}} </td>
                            </ng-container>

                            <ng-container matColumnDef="applied_to">
                                <th mat-header-cell *matHeaderCellDef> Applied To </th>
                                <td mat-cell *matCellDef="let element"> {{element.applied_to}} </td>
                            </ng-container>

                            <tr mat-header-row [style.min-height]="0" *matHeaderRowDef="displayedColumns | tableShowColumns;sticky:true;"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns | tableShowColumns;"></tr>
                        </table>
                        <ng-container *ngIf="leavesDataSource?.filteredData?.length == 0">
                            <div class="row forNoRecords">
                                <h3 class="table-no-date"> No Record found</h3>
                            </div>
                        </ng-container>
                        <app-table-loader *ngIf="leave_loader"></app-table-loader>
                        <mat-paginator #leavesPaginator [length]="leaves_page_length" [pageSize]="leaves_items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="leavesHandlePage($event)"></mat-paginator>

                    </div>

                </mat-card-content>
            </mat-card>
        </div>

        <div class="cal-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <mat-card>
                <mat-card-title>
                    <h2>Holidays</h2>
                </mat-card-title>
                <mat-card-content>
                    <div class="mat-table-responsive forFixedHeight">
                        <table mat-table [dataSource]="holidaysDataSource">

                            <ng-container matColumnDef="org_name" [sticky]="1 == 1">
                                <th mat-header-cell *matHeaderCellDef> Organization </th>
                                <td mat-cell *matCellDef="let element"> {{element?.org_name}} </td>
                            </ng-container>

                            <ng-container matColumnDef="holiday_on">
                                <th mat-header-cell *matHeaderCellDef> Date </th>
                                <td mat-cell *matCellDef="let element"> {{element?.holiday_on}} </td>
                            </ng-container>

                            <ng-container matColumnDef="holiday_for">
                                <th mat-header-cell *matHeaderCellDef> Holiday </th>
                                <td mat-cell *matCellDef="let element"> {{element?.holiday_for}} </td>
                            </ng-container>


                            <tr mat-header-row *matHeaderRowDef="holidaysDisplayedColumns | tableShowColumns;sticky:true;"></tr>
                            <tr mat-row *matRowDef="let row; columns: holidaysDisplayedColumns | tableShowColumns;"></tr>
                        </table>
                        <ng-container *ngIf="holidaysDataSource?.filteredData?.length == 0">
                            <div class="row forNoRecords">
                                <h3 class="table-no-date"> No Record found</h3>
                            </div>
                        </ng-container>
                        <app-table-loader *ngIf="holidays_loader"></app-table-loader>
                        <mat-paginator #holidaysPaginator [length]="holidays_page_length" [pageSize]="holidays_items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="holidaysHandlePage($event)"></mat-paginator>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="cal-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <mat-card>
                <mat-card-title>
                    <h2>This week status</h2>
                </mat-card-title>
                <mat-card-content>
                    <div class="mat-table-responsive forFixedHeight">
                        <table mat-table [dataSource]="weekStatusDataSource">

                            <ng-container matColumnDef="name" [sticky]="1 == 1">
                                <th mat-header-cell *matHeaderCellDef> Name </th>
                                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
                            </ng-container>

                            <ng-container matColumnDef="date">
                                <th mat-header-cell *matHeaderCellDef> Date </th>
                                <td mat-cell *matCellDef="let element"> {{element.loginDate}} </td>
                            </ng-container>

                            <ng-container matColumnDef="signin">
                                <th mat-header-cell *matHeaderCellDef> Sign In </th>
                                <td mat-cell *matCellDef="let element"> {{element.shiftClockInTime}} </td>
                            </ng-container>

                            <ng-container matColumnDef="signout">
                                <th mat-header-cell *matHeaderCellDef> Sign Out </th>
                                <td mat-cell *matCellDef="let element"> {{element.shiftClockOutTime}} </td>
                            </ng-container>

                            <ng-container matColumnDef="hours">
                                <th mat-header-cell *matHeaderCellDef> Hours </th>
                                <td mat-cell *matCellDef="let element"> {{element.loginTimeInSec | timeFormat}} </td>
                            </ng-container>


                            <tr mat-header-row *matHeaderRowDef="weekStatusDisplayedColumns;sticky:true;"></tr>
                            <tr mat-row *matRowDef="let row; columns: weekStatusDisplayedColumns;"></tr>
                        </table>

                        <ng-container *ngIf="weekStatusDataSource?.filteredData?.length == 0">
                            <div class="row forNoRecords">
                                <h3 class="table-no-date"> No Record found</h3>
                            </div>
                        </ng-container>

                        <app-table-loader *ngIf="weekStatus_loader"></app-table-loader>

                        <mat-paginator #weekStatusPaginator [length]="weekStatus_page_length" [pageSize]="weekStatus_items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="weekStatusHandlePage($event)"></mat-paginator>

                    </div>

                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="row" *appUserRole="[Role.OrganizationAdmin,Role.UserReport]">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12">
            <mat-card>
                <mat-card-title>
                    <div class="row">
                        <div class="col-lg-12">
                            <h2>Working Details</h2>

                        </div>

                    </div>

                </mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <div class="col-lg-12">
                            <form [formGroup]="AdvancedSearchForm" (ngSubmit)="AdvancedSearchFormSubmit()">

                                <div class="row">
                                    <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                                        <mat-form-field>
                                            <mat-label> From Date</mat-label>
                                            <input matInput [max]="fromMaxDate" [min]="fromMinDate" formControlName="from_date" (dateInput)="onFromDateChange($event)" [matDatepicker]="leave_from_date" (focus)="leave_from_date.open()">
                                            <mat-datepicker-toggle matSuffix [for]="leave_from_date"></mat-datepicker-toggle>
                                            <mat-datepicker #leave_from_date></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-xl-5 col-lg-5 col-md-12 col-sm-12">
                                        <mat-form-field>
                                            <mat-label> To Date</mat-label>
                                            <input matInput [max]="toMaxDate" [min]="toMinDate" formControlName="to_date" (dateInput)="onToDateChange($event)" [matDatepicker]="leave_to_date" (focus)="leave_to_date.open()">
                                            <mat-datepicker-toggle matSuffix [for]="leave_to_date"></mat-datepicker-toggle>
                                            <mat-datepicker #leave_to_date></mat-datepicker>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-2 col-lg-2 col-md-12 col-sm-12">
                                        <button mat-raised-button class="btn-int-blue forSearch" type="submit">Search</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <app-bar-chart *ngIf="isDataLoad" [chartDataSource]="chartDataSource"></app-bar-chart>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>